/**
 * Format an ISO 8601 datetime string for display using the browser's local timezone.
 * Returns '—' for empty/null values.
 * Example: "2026-07-08T07:37:39.586883Z" → "2026-07-08 07:37"
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
    .format(d)
    .replace('T', ' ');
}
